'use client'

import { ReactNode } from 'react'
import { PostHogProvider } from '@/components/providers/PostHogProvider'
import { SessionProvider } from 'next-auth/react'

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <SessionProvider>
      <PostHogProvider>{children}</PostHogProvider>
    </SessionProvider>
  )
}
